webpackJsonp([1],{

/***/ "AF0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dtho":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LSwo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  mounted: function mounted() {
    var link = document.createElement('link');
    link.href = 'https://ws3.sinaimg.cn/large/006tNc79ly1fnyr74sc8ej305m05mmx9.jpg';
    link.rel = 'shortcut icon';
    document.head.appendChild(link);
    document.title = 'SMEditor (富本文编辑器)';
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1088009c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("LSwo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./src/components/icons.js
var qiniu = function qiniu(name) {
  return 'https://om4m02471.qnssl.com/2018/editor/' + name + '.svg?2';
};

var names = ['bold', 'italic', 'underline', 'strikethrough', 'color', 'listOrdered', 'listUnordered', 'listCheck', 'indent', 'outdent', 'alignLeft', 'alignCenter', 'alignRight', 'undo', 'redo', 'removeFormat', 'insertVideo', 'insertLink', 'insertImage', 'insertLine', 'insertQuote', 'insertBlock'];
var icons = {};

names.forEach(function (name) {
  icons[name] = qiniu(name.toLowerCase());
});

/* harmony default export */ var components_icons = (icons);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ColorPicker.vue
//
//
//
//
//
//
//

// import tippy from '../../node_modules/tippy.js/dist/tippy.min.js'

/* harmony default export */ var ColorPicker = ({
  name: 'ColorPicker',
  data: function data() {
    return {
      selectColor: '#ffffff',
      names: ['白', '漆黑', '红', '橙', '黄', '葱绿', '湖蓝', '天色', '紫', '白练', '鼠', '虹', '薄卵', '蒸栗', '白绿', '蓝白', '天空', '紫水晶', '白鼠', '墨', '甚三红', '雄黄', '金子', '薄青', '白群', '薄花', '紫苑', '灰青', '石墨', '红绯', '红金', '枯茶', '绿青', '浅葱', '薄缥', '紫霞', '薄钝', '黑', '朱绯', '褐', '黑茶', '深绿', '苍蓝', '琉璃', '葡萄'],
      colors: ['#ffffff', '#0d0015', '#fe2c23', '#ff9900', '#ffd900', '#a3e043', '#37d9f0', '#4da8ee', '#aa17d0', '#f3f3f1', '#949494', '#fcdbd6', '#fde9d0', '#fff0cf', '#d4e9d6', '#def3f3', '#cee0ef', '#dfdbec', '#dcdedd', '#595856', '#ee837d', '#f8c387', '#e6b322', '#9abd9d', '#83ccd2', '#89b0ce', '#9389b1', '#c1c6ca', '#41464b', '#d51228', '#cf770b', '#8d634a', '#557b5c', '#01a3b0', '#3776a6', '#765c83', '#adadad', '#2b2b2b', '#a91913', '#884702', '#563725', '#00552e', '#00767a', '#194e77', '#530e6f']
    };
  },

  props: ['ColorPickerClick'],
  methods: {
    handleColorHover: function handleColorHover(index) {
      this.selectColor = this.colors[index];
      // tippy(document.querySelectorAll('.color-picker-options span')[index])
    },
    handleColorClick: function handleColorClick(index) {
      this.selectColor = this.colors[index];
      this.ColorPickerClick(this.selectColor);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3afe180","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorPicker.vue
var ColorPicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"color-picker-options"},[_vm._l((_vm.colors),function(color,index){return _c('span',{staticClass:"ql-picker-item ql-primary",style:({backgroundColor: color}),attrs:{"data-light":"light","data-value":color,"title":_vm.names[index]},on:{"click":function($event){_vm.handleColorClick(index)},"mouseover":function($event){_vm.handleColorHover(index)}}})}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectColor),expression:"selectColor"}],staticClass:"color-input",attrs:{"type":"text","autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false","maxlength":"6"},domProps:{"value":(_vm.selectColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectColor=$event.target.value}}})],2)}
var ColorPicker_staticRenderFns = []
var ColorPicker_esExports = { render: ColorPicker_render, staticRenderFns: ColorPicker_staticRenderFns }
/* harmony default export */ var components_ColorPicker = (ColorPicker_esExports);
// CONCATENATED MODULE: ./src/components/ColorPicker.vue
function ColorPicker_injectStyle (ssrContext) {
  __webpack_require__("c9KF")
}
var ColorPicker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ColorPicker___vue_template_functional__ = false
/* styles */
var ColorPicker___vue_styles__ = ColorPicker_injectStyle
/* scopeId */
var ColorPicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ColorPicker___vue_module_identifier__ = null
var ColorPicker_Component = ColorPicker_normalizeComponent(
  ColorPicker,
  components_ColorPicker,
  ColorPicker___vue_template_functional__,
  ColorPicker___vue_styles__,
  ColorPicker___vue_scopeId__,
  ColorPicker___vue_module_identifier__
)

/* harmony default export */ var src_components_ColorPicker = (ColorPicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TitlePicker.vue
//
//
//
//
//
//
//
//
//


/* harmony default export */ var TitlePicker = ({
  name: 'FontSizePicker',
  data: function data() {
    return {
      sizes: ['H1', 'H2', 'H3', 'H4', 'H5', '正文'],
      current: '正文'
    };
  },

  props: ['titlePickerClick'],
  methods: {
    getHtml: function getHtml(size, index) {
      if (index === this.sizes.length - 1) {
        return size;
      }
      return '<' + size + '>' + size + '</' + size + '>';
    },
    handleFontSizeClick: function handleFontSizeClick(size, index) {
      this.current = size;
      this.titlePickerClick(size, index);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042e5a0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitlePicker.vue
var TitlePicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-options"},[_c('ul',_vm._l((_vm.sizes),function(size,index){return _c('li',{class:{fontSizeActive: _vm.current === size},on:{"click":function($event){$event.stopPropagation();_vm.handleFontSizeClick(size, index)}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHtml(size, index))}})])}))])}
var TitlePicker_staticRenderFns = []
var TitlePicker_esExports = { render: TitlePicker_render, staticRenderFns: TitlePicker_staticRenderFns }
/* harmony default export */ var components_TitlePicker = (TitlePicker_esExports);
// CONCATENATED MODULE: ./src/components/TitlePicker.vue
function TitlePicker_injectStyle (ssrContext) {
  __webpack_require__("rQxg")
}
var TitlePicker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TitlePicker___vue_template_functional__ = false
/* styles */
var TitlePicker___vue_styles__ = TitlePicker_injectStyle
/* scopeId */
var TitlePicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TitlePicker___vue_module_identifier__ = null
var TitlePicker_Component = TitlePicker_normalizeComponent(
  TitlePicker,
  components_TitlePicker,
  TitlePicker___vue_template_functional__,
  TitlePicker___vue_styles__,
  TitlePicker___vue_scopeId__,
  TitlePicker___vue_module_identifier__
)

/* harmony default export */ var src_components_TitlePicker = (TitlePicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InsertLink.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var InsertLink = ({
  name: 'InsertLink',
  data: function data() {
    return {
      link: '',
      text: ''
    };
  },

  props: ['insertLink', 'cancel', 'propText'],
  methods: {
    conformClick: function conformClick() {
      this.insertLink(this.link, this.text);
    },
    cancelClick: function cancelClick() {
      this.cancel();
    }
  },
  watch: {
    'propText': function propText() {
      this.text = this.propText;
      this.link = this.propLink;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5176eec6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InsertLink.vue
var InsertLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insert-link"},[_c('div',{staticClass:"insert-link-box"},[_c('span',{staticClass:"cancel",on:{"click":_vm.cancelClick}},[_vm._v("X")]),_vm._v(" "),_c('p',[_vm._v("插入链接")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],attrs:{"type":"text","name":"text","placeholder":"链接文本"},domProps:{"value":(_vm.text)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.conformClick($event)},"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.link),expression:"link"}],attrs:{"type":"text","name":"link","placeholder":"链接地址"},domProps:{"value":(_vm.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.link=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.conformClick}},[_vm._v(" 确认")])])])}
var InsertLink_staticRenderFns = []
var InsertLink_esExports = { render: InsertLink_render, staticRenderFns: InsertLink_staticRenderFns }
/* harmony default export */ var components_InsertLink = (InsertLink_esExports);
// CONCATENATED MODULE: ./src/components/InsertLink.vue
function InsertLink_injectStyle (ssrContext) {
  __webpack_require__("xT5d")
}
var InsertLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InsertLink___vue_template_functional__ = false
/* styles */
var InsertLink___vue_styles__ = InsertLink_injectStyle
/* scopeId */
var InsertLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InsertLink___vue_module_identifier__ = null
var InsertLink_Component = InsertLink_normalizeComponent(
  InsertLink,
  components_InsertLink,
  InsertLink___vue_template_functional__,
  InsertLink___vue_styles__,
  InsertLink___vue_scopeId__,
  InsertLink___vue_module_identifier__
)

/* harmony default export */ var src_components_InsertLink = (InsertLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InsertVideo.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var InsertVideo = ({
  name: 'InsertVideo',
  data: function data() {
    return {
      text: ''
    };
  },

  props: ['insertVideo', 'cancel'],
  methods: {
    conformClick: function conformClick() {
      this.insertVideo(this.text);
    },
    cancelClick: function cancelClick() {
      this.cancel();
    }
  },
  mounted: function mounted() {
    document.querySelector('.insert-video-box input').focus();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570c95ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InsertVideo.vue
var InsertVideo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insert-video"},[_c('div',{staticClass:"insert-video-box"},[_c('span',{staticClass:"cancel",on:{"click":_vm.cancelClick}},[_vm._v("X")]),_vm._v(" "),_c('p',[_vm._v("插入视频")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],attrs:{"type":"text","name":"text","placeholder":"复制通用代码 <iframe src='...'></iframe>"},domProps:{"value":(_vm.text)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.conformClick($event)},"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.conformClick}},[_vm._v(" 确认")])])])}
var InsertVideo_staticRenderFns = []
var InsertVideo_esExports = { render: InsertVideo_render, staticRenderFns: InsertVideo_staticRenderFns }
/* harmony default export */ var components_InsertVideo = (InsertVideo_esExports);
// CONCATENATED MODULE: ./src/components/InsertVideo.vue
function InsertVideo_injectStyle (ssrContext) {
  __webpack_require__("Um8d")
}
var InsertVideo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InsertVideo___vue_template_functional__ = false
/* styles */
var InsertVideo___vue_styles__ = InsertVideo_injectStyle
/* scopeId */
var InsertVideo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InsertVideo___vue_module_identifier__ = null
var InsertVideo_Component = InsertVideo_normalizeComponent(
  InsertVideo,
  components_InsertVideo,
  InsertVideo___vue_template_functional__,
  InsertVideo___vue_styles__,
  InsertVideo___vue_scopeId__,
  InsertVideo___vue_module_identifier__
)

/* harmony default export */ var src_components_InsertVideo = (InsertVideo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Insert.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Insert = ({
  name: 'Insert',
  data: function data() {
    return {
      icons: components_icons,
      labels: ['图片', '分割线', '视频', '代码块'],
      names: ['insertImage', 'insertLine', 'insertVideo', 'insertBlock']
    };
  },

  props: ['insertImageClick', 'insertLink', 'insertLine', 'insertVideo', 'insertBlock', 'uploadImages'],
  methods: {
    handleFileChange: function handleFileChange() {
      var input = this.$refs.input[0];
      var files = input.files;
      this.uploadImages(files);
    },
    insertClick: function insertClick(key, index) {
      if (this[key]) {
        this[key]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8987cc0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Insert.vue
var Insert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insert-options-items"},[_c('ul',_vm._l((_vm.names),function(key,index){return _c('li',{on:{"click":function($event){_vm.insertClick(key, index)}}},[(index === 0)?_c('input',{ref:"input",refInFor:true,attrs:{"id":"images_upload","type":"file","accept":"image/gif,image/jpeg,image/jpg,image/png,image/svg","multiple":"multiple"},on:{"change":_vm.handleFileChange}}):_vm._e(),_vm._v(" "),_c('img',{class:key,attrs:{"src":_vm.icons[key]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.labels[index]))])])}))])}
var Insert_staticRenderFns = []
var Insert_esExports = { render: Insert_render, staticRenderFns: Insert_staticRenderFns }
/* harmony default export */ var components_Insert = (Insert_esExports);
// CONCATENATED MODULE: ./src/components/Insert.vue
function Insert_injectStyle (ssrContext) {
  __webpack_require__("AF0Q")
}
var Insert_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Insert___vue_template_functional__ = false
/* styles */
var Insert___vue_styles__ = Insert_injectStyle
/* scopeId */
var Insert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Insert___vue_module_identifier__ = null
var Insert_Component = Insert_normalizeComponent(
  Insert,
  components_Insert,
  Insert___vue_template_functional__,
  Insert___vue_styles__,
  Insert___vue_scopeId__,
  Insert___vue_module_identifier__
)

/* harmony default export */ var src_components_Insert = (Insert_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SMEditor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import tippy from '../../node_modules/tippy.js/dist/tippy.min.js'
var remove = function remove(arr, val) {
  var index = arr.indexOf(val);
  if (index > -1) {
    arr.splice(index, 1);
  }
};

var editorElement = function editorElement() {
  return document.querySelector('.smeditor .input-area');
};

/* harmony default export */ var SMEditor = ({
  name: 'smeditor',
  components: {
    'color-picker': src_components_ColorPicker,
    'title-picker': src_components_TitlePicker,
    'insert-options': src_components_Insert,
    'insert-link': src_components_InsertLink,
    'insert-video': src_components_InsertVideo
  },
  props: ['config'],
  data: function data() {
    return {
      // 图标
      icons: components_icons,
      // 样式
      styles: [],
      // 基本样式名称
      basicIcons: ['bold', 'underline', 'italic', 'strikethrough'],
      basicStyleNames: ['粗体', '斜体', '下划线', '中划线'],
      // 调色盘是否显示
      isColorPickerShow: false,
      // 标题选择是否显示
      isTitlePickerShow: false,
      // 字号选项是否显示
      isFontSizePickerShow: false,
      // 插入选项是否显示
      isInsertShow: false,
      // 插入链接是否显示
      isInsertLinkShow: false,
      // 插入视频是否显示
      isInsertVideoShow: false,
      // 选中文字内容
      selectWords: '',
      // 字号
      fontSize: 16,
      // 光标
      cursor: {},
      // 鼠标选中节点
      selectNode: {},
      buttonsBarFixed: false,
      selectImageNode: null,
      insertLinkSection: {
        node: '',
        start: 0,
        end: 0,
        text: '',
        link: ''
      }
    };
  },

  methods: {
    // 回车事件
    kenter: function kenter(e) {
      e.stopPropagation();
      if (this.styles.length === 0) {
        return false;
      }
    },

    // 鼠标事件
    mouseup: function mouseup() {
      var _this = this;

      this.selectNode = getSelectedNode();
      var str = window.getSelection().toString();
      if (str.length < 1) {
        return false;
      }
      this.selectWords = str;
      setTimeout(function () {
        _this.selectWords = '';
      }, 1500);
    },

    // 鼠标事件
    mouseover: function mouseover(event) {
      var target = '';
      event.path.forEach(function (el) {
        if (el.localName === 'button' && target === '') {
          target = el;
        }
      });
      // tippy(target, {
      //   placement: 'bottom',
      //   animation: 'shift-away',
      //   duration: 100,
      //   arrow: true
      // })
    },

    // 重做
    redo: function redo() {
      document.execCommand('redo');
    },

    // 撤销
    undo: function undo() {
      document.execCommand('undo');
    },

    // 移除格式
    removeFormat: function removeFormat() {
      document.execCommand('removeFormat', false, '');
      document.execCommand('insertHTML', false, '<p></p>');
      this.styles = [];
      this.FontSize = 16;
    },

    // 字号选项点击
    fontSizePickerClick: function fontSizePickerClick(size, index) {
      document.execCommand('FontSize', false, index + 1);
      this.fontSize = size;
      this.closeAlert();
    },

    // 标题按钮点击
    titleButtonClick: function titleButtonClick() {
      getCursor(this);
      this.isTitlePickerShow = !this.isTitlePickerShow;
    },

    // 标题选项点击
    titlePickerClick: function titlePickerClick(size, index) {
      this.closeAlert();
      var html = '';
      restoreCursor(this);
      var node = getSelectedNode();
      console.log(node, node.localName);
      // 一共分六种情况
      // 1. empty <h>
      // 2. empty <p>
      if (node.className === editorElement().className || node.className.startsWith('smeditor')) {
        if (size === '正文') {
          document.execCommand('insertHTML', false, '<p><span><br></span></p>');
        } else {
          document.execCommand('insertHTML', false, '<' + size + '><span><br></span></' + size + '>');
        }
        return false;
      }
      // 3 h -> p
      // 4 h -> h+
      // 5 p -> h
      // 6 p -> p
      if (node.localName.startsWith('h') && size === '正文') {
        html = '<p>' + node.innerHTML + '</p>';
      } else if (node.localName.startsWith('h') && size.startsWith('H')) {
        html = '<' + size + '>' + node.innerHTML + '</' + size + '>';
      } else if (node.innerHTML.length > 0 && node.localName.startsWith('h') === false && size !== '正文') {
        html = '<' + size + '>' + node.innerHTML + '</' + size + '>';
      } else {
        html = '<p>' + node.innerHTML + '</p>';
      }
      restoreCursor(this);
      node.outerHTML = '';
      document.execCommand('insertHTML', false, html);
      // const range = document.createRange()
      // range.selectNodeContents(node)
      // range.collapse(false)
      // const selection = window.getSelection()
      // selection.removeAllRanges()
      // selection.addRange(range)
    },

    // 基本样式点击
    basicStyleClick: function basicStyleClick(name) {
      var _this2 = this;

      execCmd(this, function () {
        document.execCommand(name, false, '');
        if (_this2.styles.indexOf(name) === -1) {
          _this2.styles.push(name);
        } else {
          remove(_this2.styles, name);
        }
      });
    },

    // 调色盘点击
    colorPickerClick: function colorPickerClick(color) {
      var _this3 = this;

      // document.querySelector('.ql-color-label').style.fill = color
      execCmd(this, function () {
        document.execCommand('forecolor', false, color);
        _this3.closeAlert();
      });
    },

    // 点击插入图片
    insertImageClick: function insertImageClick(size, index) {
      this.closeAlert();
    },

    // 上传图片
    uploadImages: function uploadImages(files) {
      var _this4 = this;

      from_default()(files).forEach(function (file) {
        _this4.upload(file, function (url) {
          _this4.insertImageHtml(url);
        });
      });
    },
    upload: function upload(file, success) {
      var url = this.config.uploadUrl;
      var xhr = new XMLHttpRequest();
      var form = new FormData();
      var self = this;
      form.append(this.config.uploadName, file);
      xhr.open('POST', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var json = JSON.parse(xhr.responseText);
            var imgUrl = self.config.uploadCallback(json);
            success(imgUrl);
          } else {
            if (self.config.uploadFailed) {
              self.config.uploadFailed(xhr.responseText);
            }
            // 测试网站, 模拟上传
            if (location.href.indexOf('ericjj.com/smeditor.github.io') > 0 || location.href.indexOf('127.0.0.1') > 0) {
              var _imgUrl = self.config.uploadCallback({});
              success(_imgUrl);
            }
          }
        }
      };
      xhr.send(form);
    },
    insertImageHtml: function insertImageHtml(url) {
      var _this5 = this;

      document.execCommand('insertHTML', false, '\n              <br><div class="image-desc" style="text-align: center; color: #333;">\n                <img class="uploaded-img" src=' + url + ' max-width="100%" width="auto" height="auto">\n                <br>\n                <div class="image-caption" style="min-width: 20%; max-width: 80%; height: 35px; display: inline-block; padding: 10px 10px 0px 10px; margin: 0 auto; border-bottom: 1px solid #d9d9d9; font-size: 16px; color: #999; content: "";"></div>\n              </div>');
      var last = null;
      editorElement().querySelectorAll('img').forEach(function (el) {
        el.onclick = function () {
          if (el.className.indexOf('img-onclick') < 0) {
            if (last !== null) {
              last.className = last.className.replace('img-onclick', '');
            }
            el.className += ' img-onclick';
            _this5.selectImageNode = el;
            last = el;
          } else {
            el.className = el.className.replace('img-onclick', '');
            _this5.selectImageNode = null;
          }
        };
      });
    },

    // 点击插入链接
    insertLinkClick: function insertLinkClick() {
      this.closeAlert();
      this.insertLinkSection.text = window.getSelection().toString();
      getCursor(this);
      this.isInsertLinkShow = true;
    },

    // 插入链接
    insertLink: function insertLink(url, title) {
      restoreCursor(this);
      var node = getSelectedNode();
      if (node.localName === 'a') {
        node.outerHTML = '<a href=' + url + ' target="_blank">' + title + '</>';
        return false;
      }
      document.execCommand('insertHTML', false, '<a href=' + url + ' target="_blank">' + title + '</>');
    },

    // 取消插入链接
    insertLinkCancel: function insertLinkCancel() {
      this.closeAlert();
      this.isInsertLinkShow = false;
    },

    // 点击插入链接
    insertVideoClick: function insertVideoClick() {
      var _this6 = this;

      this.closeAlert();
      setTimeout(function () {
        _this6.isInsertVideoShow = true;
      }, 200);
      getCursor(this);
    },

    // 插入链接
    insertVideo: function insertVideo(text) {
      restoreCursor(this);
      document.execCommand('insertHTML', false, text);
      this.closeAlert();
    },

    // 取消插入链接
    insertVideoCancel: function insertVideoCancel() {
      this.closeAlert();
    },

    // 插入一条线
    insertLine: function insertLine() {
      this.closeAlert();
      document.execCommand('insertHTML', false, '<p><hr></p>');
    },

    // 插入代码块
    insertBlock: function insertBlock() {
      this.closeAlert();
      document.execCommand('insertHTML', false, '<pre><code><span><br><span></code></pre>');
    },

    // 插入引用
    insertQuote: function insertQuote() {
      var node = getSelectedNode();
      // console.log(node)
      if (node.className === 'input-area') {
        return false;
      }
      if (node.localName === 'blockquote' && node.parentNode.className !== 'input-area') {
        var str = node.innerHTML;
        console.log(node.parentNode);
        node.parentNode.outerHTML = '';
        document.execCommand('insertHTML', false, '<br><p>' + str + '</p>');
        this.insertEmptyP();
      } else if (node.className === 'blockquote') {
        var _str = node.innerHTML;
        console.log(_str);
        document.execCommand('insertHTML', false, '<p>' + _str + '</p>');
        this.insertEmptyP();
        node.outerHTML = '';
      } else if (node.innerHTML.length > 0 && node.className !== 'smeditor' && node.className !== editorElement().className && node.className !== 'blockquote') {
        document.execCommand('insertHTML', false, '<div class="blockquote"><blockquote style="color: #B2B2B2; padding-left: 15px; border-left: 5px solid #B2B2B2; margin-top: 0px; margin-bottom: 0px;">' + node.innerHTML + '</blockquote></div>');
        node.outerHTML = '';
      } else {
        document.execCommand('insertHTML', false, '<div class="blockquote"><blockquote style="color: #B2B2B2; padding-left: 15px; border-left: 5px solid #B2B2B2; margin-top: 0px; margin-bottom: 0px;"><span><br></span></blockquote></div>');
      }
    },

    // 插入 有序/无序 列表
    insertList: function insertList(name) {
      this.closeAlert();
      document.execCommand('insert' + name, false, '');
    },

    // 插入 todo , 暂时不做
    insertCheck: function insertCheck() {
      this.closeAlert();
      document.execCommand('insertHTML', false, '\n        <ul class="unchecked-list"><li class="unchecked">&nbsp</li></ul>\n      ');
      document.querySelectorAll('.unchecked-list').forEach(function (ul) {
        ul.childNodes.forEach(function (li) {
          li.onclick = function (event) {
            var name = event.target.className === 'unchecked' ? 'checked' : 'unchecked';
            event.target.className = name;
            console.log(event.target.className);
          };
        });
      });
    },

    // 缩进+
    indent: function indent() {
      document.execCommand('indent', false, null);
    },

    // 缩进-
    outdent: function outdent() {
      document.execCommand('outdent', false, null);
    },

    // 对齐
    align: function align(name) {
      execCmd(this, function () {
        document.execCommand('Justify' + name);
      });
    },

    // 备份
    backupClick: function backupClick() {
      window.localStorage.setItem('smeditor', editorElement().innerHTML);
    },

    // 恢复
    restoreClick: function restoreClick() {
      editorElement().innerHTML = window.localStorage.getItem('smeditor') || '';
    },

    // 预览
    previewClick: function previewClick() {
      window.localStorage.setItem('smeditorPreview', editorElement().innerHTML);

      var _$router$resolve = this.$router.resolve({
        name: 'Preview'
      }),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },

    // 关闭弹窗
    closeAlert: function closeAlert() {
      var _this7 = this;

      setTimeout(function () {
        _this7.isFontSizePickerShow = false;
        _this7.isInsertShow = false;
        _this7.isColorPickerShow = false;
        _this7.isInsertVideoShow = false;
        _this7.isTitlePickerShow = false;
      }, 200);
    },
    insertEmptyP: function insertEmptyP() {
      document.execCommand('insertHTML', false, '<p><span></br></span></p>');
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    setTimeout(function () {
      editorElement().focus();
      _this8.insertEmptyP();
      window.addEventListener('scroll', function () {
        if (_this8.config.onScroll) {
          _this8.config.onScroll();
        }
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var offsetTop = document.querySelector('.smeditor').offsetTop;
        if (scrollTop > offsetTop) {
          _this8.buttonsBarFixed = true;
        } else {
          _this8.buttonsBarFixed = false;
        }
      });
    }, 100);
    addEvents(this);
  }
});

function addEvents(self) {
  editorElement().onfocus = function (event) {
    self.closeAlert();
  };
  // 回车事件
  editorElement().onkeypress = function (event) {
    var el = getSelectedNode();
    if (event.keyCode === 13 && isImageCaption(el)) {
      document.execCommand('removeFormat', false, '');
      this.innerHTML = this.innerHTML + '<p><br></p>';
      document.getSelection().collapse(this, this.childNodes.length - 1);
      return false;
    }
    if (event.keyCode === 13 && el.className === 'blockquote' && el.lastChild.innerHTML === '<br>') {
      el.lastChild.innerHTML = '';
      document.execCommand('removeFormat', false, '');
      this.innerHTML = this.innerHTML + '<p></p>';
      document.getSelection().collapse(this, this.childNodes.length - 1);
      return false;
    }

    if (event.keyCode === 13 && el.localName === 'pre' && el.lastChild.innerHTML === '<br>') {
      el.lastChild.innerHTML = '';
      document.execCommand('removeFormat', false, '');
      this.innerHTML = this.innerHTML + '<p><span><br></span></p>';
      document.getSelection().collapse(this, this.childNodes.length - 1);
      return false;
    }
  };
  // 删除事件
  editorElement().onkeydown = function (event) {
    if (self.selectImageNode) {
      console.log(self.selectImageNode.parentNode);
      if (self.selectImageNode.parentNode && self.selectImageNode.parentNode.className === 'image-desc') {
        self.selectImageNode.parentNode.outerHTML = '';
        return false;
      }
      self.selectImageNode.outerHTML = '';
      return false;
    }
    var el = getSelectedNode();
    if (event.keyCode === 8 && isImageDesc(el)) {
      el.innerHTML = '<p></p>';
      return false;
    }
    if (el.innerHTML.length <= 1 && event.keyCode === 8 && isImageCaption(el)) {
      el.innerHTML = '';
      return false;
    }
    if (getSelectedNode().innerHTML.length === 0) {
      document.execCommand('insertHTML', false, '<p><span></br></span></p>');
    }
  };
  editorElement().addEventListener('paste', function (event) {
    var items = (event.clipboardData || event.originalEvent.clipboardData).items;
    for (var index in items) {
      var item = items[index];
      if (item.kind === 'file') {
        event.preventDefault();
        var blob = item.getAsFile();
        self.upload(blob, function (url) {
          self.insertImageHtml(url);
        });
      }
    }
  }, false);
}

function execCmd(self, callback) {
  getCursor(self);
  restoreCursor(self);
  callback();
}

function getCursor(self) {
  self.cursor = window.getSelection().getRangeAt(0);
}

// function delHtmlTag (str) {
//   return str.replace(/<[^>]+>/g, '')
// }

function isImageCaption(el) {
  return el.className === 'image-caption';
}

function isImageDesc(el) {
  return el.className === 'image-desc';
}

function getSelectedNode() {
  if (document.selection) {
    return document.selection.createRange().parentElement();
  } else {
    var selection = window.getSelection();
    if (selection.rangeCount > 0) {
      return selection.getRangeAt(0).startContainer.parentNode;
    }
  }
}

function restoreCursor(self) {
  self.closeAlert();
  self.isInsertLinkShow = false;
  editorElement().focus();
  var savedRange = self.cursor;
  if (window.getSelection) {
    var s = window.getSelection();
    if (s.rangeCount > 0) {
      s.removeAllRanges();
    }
    s.addRange(savedRange);
  } else if (document.createRange) {
    window.getSelection().addRange(savedRange);
  } else if (document.selection) {
    savedRange.select();
  }
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b18f84a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMEditor.vue
var SMEditor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smeditor",attrs:{"id":"smeditor"}},[_c('div',{staticClass:"buttons",class:_vm.buttonsBarFixed == true ? 'isFixed' :''},[_c('button',{staticClass:"undo",attrs:{"type":"button","title":"撤销"},on:{"click":_vm.undo,"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.undo}})]),_vm._v(" "),_c('button',{staticClass:"redo",attrs:{"type":"button","title":"重做"},on:{"click":_vm.redo,"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.redo}})]),_vm._v(" "),_c('button',{staticClass:"remove-format",attrs:{"type":"button","title":"清除"},on:{"click":_vm.removeFormat,"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.removeFormat}})]),_vm._v(" "),_c('button',{staticClass:"set-font",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.titleButtonClick($event)}}},[_c('span',[_vm._v("H")]),_vm._v(" "),_c('title-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTitlePickerShow),expression:"isTitlePickerShow"}],attrs:{"titlePickerClick":_vm.titlePickerClick}})],1),_vm._v(" "),_vm._l((_vm.basicIcons),function(name,index){return _c('button',{class:{buttonsActive: _vm.styles.indexOf(name) > -1},attrs:{"type":"button","title":_vm.basicStyleNames[Object.keys(_vm.basicIcons).indexOf(name)]},on:{"click":function($event){_vm.basicStyleClick(name)},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons[name]}})])}),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"文本颜色"},on:{"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.color},on:{"click":function($event){_vm.isColorPickerShow = !_vm.isColorPickerShow}}}),_vm._v(" "),_c('color-picker',{directives:[{name:"show",rawName:"v-show",value:(_vm.isColorPickerShow),expression:"isColorPickerShow"}],attrs:{"ColorPickerClick":_vm.colorPickerClick}})],1),_vm._v(" "),_c('button',{staticClass:"indent",attrs:{"type":"button","title":"增加缩进"},on:{"click":function($event){$event.stopPropagation();_vm.indent($event)},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.indent}})]),_vm._v(" "),_c('button',{staticClass:"outdent",attrs:{"type":"button","title":"减少缩进"},on:{"click":function($event){$event.stopPropagation();_vm.outdent($event)},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.outdent}})]),_vm._v(" "),_c('button',{staticClass:"insert-ol",attrs:{"type":"button","title":"有序列表"},on:{"click":function($event){_vm.insertList("OrderedList")},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.listOrdered}})]),_vm._v(" "),_c('button',{staticClass:"insert-ul",attrs:{"type":"button","title":"无序列表"},on:{"click":function($event){_vm.insertList("UnorderedList")},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.listUnordered}})]),_vm._v(" "),_c('button',{staticClass:"align-left",attrs:{"type":"button","title":"左对齐"},on:{"click":function($event){_vm.align("Left")},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.alignLeft}})]),_vm._v(" "),_c('button',{staticClass:"align-center",attrs:{"type":"button","title":"居中对齐"},on:{"click":function($event){_vm.align("Center")},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.alignCenter}})]),_vm._v(" "),_c('button',{staticClass:"align-right",attrs:{"type":"button","title":"右对齐"},on:{"click":function($event){_vm.align("Right")},"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.alignRight}})]),_vm._v(" "),_c('button',{staticClass:"insert-quote",attrs:{"type":"button"},on:{"click":_vm.insertQuote}},[_c('img',{attrs:{"src":_vm.icons.insertQuote}})]),_vm._v(" "),_c('button',{staticClass:"insert-link",attrs:{"type":"button","title":"插入链接"},on:{"click":_vm.insertLinkClick,"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}},[_c('img',{attrs:{"src":_vm.icons.insertLink}})]),_vm._v(" "),_c('button',{staticClass:"insert-options",attrs:{"type":"button"},on:{"click":function($event){_vm.isInsertShow = !_vm.isInsertShow}}},[_c('span',{staticClass:"insert-options-label"}),_vm._v(" "),_c('insert-options',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInsertShow),expression:"isInsertShow"}],attrs:{"insertImage":_vm.insertImageClick,"insertLine":_vm.insertLine,"insertVideo":_vm.insertVideoClick,"insertBlock":_vm.insertBlock,"uploadImages":_vm.uploadImages}})],1),_vm._v(" "),_c('button',{staticClass:"backup",attrs:{"type":"button","title":"Ctrl + S"},on:{"click":_vm.backupClick,"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}}),_vm._v(" "),_c('button',{staticClass:"restore",attrs:{"type":"button"},on:{"click":_vm.restoreClick}}),_vm._v(" "),_c('button',{staticClass:"preview",attrs:{"type":"button","title":"Ctrl + P"},on:{"click":_vm.previewClick,"mouseover":function($event){$event.stopPropagation();_vm.mouseover($event)}}})],2),_vm._v(" "),_c('div',{staticClass:"input-area",attrs:{"contenteditable":"true","autocorrect":"off","autocomplete":"off","spellcheck":"false","id":"input-area"},on:{"mouseup":_vm.mouseup,"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.kenter($event)},function($event){if(!('button' in $event)&&$event.keyCode!==83){ return null; }if(!$event.ctrlKey){ return null; }_vm.backupClick($event)},function($event){if(!('button' in $event)&&$event.keyCode!==80){ return null; }if(!$event.ctrlKey){ return null; }_vm.previewClick($event)}]}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectWords),expression:"selectWords"}],staticClass:"select-words"},[_vm._v(_vm._s(_vm.selectWords.length)+"个字")]),_vm._v(" "),_c('insert-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInsertLinkShow),expression:"isInsertLinkShow"}],attrs:{"insertLink":_vm.insertLink,"propText":_vm.insertLinkSection.text,"propLink":_vm.insertLinkSection.link,"cancel":_vm.insertLinkCancel}}),_vm._v(" "),_c('insert-video',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInsertVideoShow),expression:"isInsertVideoShow"}],attrs:{"insertVideo":_vm.insertVideo,"cancel":_vm.insertVideoCancel}})],1)}
var SMEditor_staticRenderFns = []
var SMEditor_esExports = { render: SMEditor_render, staticRenderFns: SMEditor_staticRenderFns }
/* harmony default export */ var components_SMEditor = (SMEditor_esExports);
// CONCATENATED MODULE: ./src/components/SMEditor.vue
function SMEditor_injectStyle (ssrContext) {
  __webpack_require__("rEWb")
}
var SMEditor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SMEditor___vue_template_functional__ = false
/* styles */
var SMEditor___vue_styles__ = SMEditor_injectStyle
/* scopeId */
var SMEditor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SMEditor___vue_module_identifier__ = null
var SMEditor_Component = SMEditor_normalizeComponent(
  SMEditor,
  components_SMEditor,
  SMEditor___vue_template_functional__,
  SMEditor___vue_styles__,
  SMEditor___vue_scopeId__,
  SMEditor___vue_module_identifier__
)

/* harmony default export */ var src_components_SMEditor = (SMEditor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/VFooter.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var VFooter = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e91fbcae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VFooter.vue
var VFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vfooter"},[_c('li',[_vm._v("@2018")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"donation","target":"_blank"}},[_vm._v("捐助")])],1)])}
var VFooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://github.com/ericjjj/smeditor","target":"_blank"}},[_vm._v("Github")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://github.com/ericjjj/smeditor/issues","target":"_blank"}},[_vm._v("反馈")])])}]
var VFooter_esExports = { render: VFooter_render, staticRenderFns: VFooter_staticRenderFns }
/* harmony default export */ var views_VFooter = (VFooter_esExports);
// CONCATENATED MODULE: ./src/views/VFooter.vue
function VFooter_injectStyle (ssrContext) {
  __webpack_require__("m4rd")
}
var VFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VFooter___vue_template_functional__ = false
/* styles */
var VFooter___vue_styles__ = VFooter_injectStyle
/* scopeId */
var VFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VFooter___vue_module_identifier__ = null
var VFooter_Component = VFooter_normalizeComponent(
  VFooter,
  views_VFooter,
  VFooter___vue_template_functional__,
  VFooter___vue_styles__,
  VFooter___vue_scopeId__,
  VFooter___vue_module_identifier__
)

/* harmony default export */ var src_views_VFooter = (VFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//


// import SMEditor from '../../release/smeditor.js'

// import c from './config.json'
var config = {
  // 接口地址
  uploadUrl: 'https://jsonplaceholder.typicode.com/posts/',
  // form 里的 filename
  uploadName: 'upload_file',
  // 其他参数
  uploadParams: {},
  sticky: true,
  // 上传成功回调
  uploadCallback: function uploadCallback(data) {
    return 'https://ws2.sinaimg.cn/large/006tNc79ly1fo48pgf714j30eh08rdg5.jpg';
  },
  // 上传失败回调, 可选
  uploadFailed: function uploadFailed(err) {
    // console.log('仅供测试, 并非真正上传')
    alert('仅供测试, 并非真正上传!', err);
  }
};

/* harmony default export */ var Home = ({
  name: 'app',
  components: {
    'smeditor': src_components_SMEditor,
    'vfooter': src_views_VFooter
  },
  data: function data() {
    return {
      config: config
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f368c88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"smeditor-wrapper"},[_c('smeditor',{attrs:{"config":_vm.config}})],1),_vm._v(" "),_c('vfooter')],1)}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._v("SMEditor\n    "),_c('span',[_vm._v("(石墨文档编辑器)")])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var views_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/views/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("Dtho")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  views_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_views_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Donation.vue
//
//
//
//
//

/* harmony default export */ var Donation = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e39ed56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Donation.vue
var Donation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Donation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donation"},[_c('img',{attrs:{"src":"https://ws4.sinaimg.cn/large/006tNc79ly1fnyqbykokqj30w00w0wh9.jpg"}})])}]
var Donation_esExports = { render: Donation_render, staticRenderFns: Donation_staticRenderFns }
/* harmony default export */ var views_Donation = (Donation_esExports);
// CONCATENATED MODULE: ./src/views/Donation.vue
function Donation_injectStyle (ssrContext) {
  __webpack_require__("g4YQ")
}
var Donation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Donation___vue_template_functional__ = false
/* styles */
var Donation___vue_styles__ = Donation_injectStyle
/* scopeId */
var Donation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Donation___vue_module_identifier__ = null
var Donation_Component = Donation_normalizeComponent(
  Donation,
  views_Donation,
  Donation___vue_template_functional__,
  Donation___vue_styles__,
  Donation___vue_scopeId__,
  Donation___vue_module_identifier__
)

/* harmony default export */ var src_views_Donation = (Donation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Preview.vue
//
//
//
//
//

/* harmony default export */ var Preview = ({
  data: function data() {
    return {
      content: ''
    };
  },
  mounted: function mounted() {
    this.content = window.localStorage.getItem('smeditorPreview');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d60747b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Preview.vue
var Preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"preview-wrapper",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var Preview_staticRenderFns = []
var Preview_esExports = { render: Preview_render, staticRenderFns: Preview_staticRenderFns }
/* harmony default export */ var views_Preview = (Preview_esExports);
// CONCATENATED MODULE: ./src/views/Preview.vue
function Preview_injectStyle (ssrContext) {
  __webpack_require__("ihk8")
}
var Preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Preview___vue_template_functional__ = false
/* styles */
var Preview___vue_styles__ = Preview_injectStyle
/* scopeId */
var Preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Preview___vue_module_identifier__ = null
var Preview_Component = Preview_normalizeComponent(
  Preview,
  views_Preview,
  Preview___vue_template_functional__,
  Preview___vue_styles__,
  Preview___vue_scopeId__,
  Preview___vue_module_identifier__
)

/* harmony default export */ var src_views_Preview = (Preview_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_views_Home
  }, {
    path: '/preview',
    name: 'Preview',
    component: src_views_Preview
  }, {
    path: '/donation',
    name: 'Donation',
    component: src_views_Donation
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;
/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Um8d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9KF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g4YQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ihk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m4rd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rEWb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rQxg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xT5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f7bd84e561d6d7abfd05.js